import { SimpleTableComponent } from './SimpleTableComponent'
import { useSimpleTable, type UseSimpleTableProps } from './useSimpleTable'

/**
 * A simple table component that uses @tanstack/react-table for rendering and managing table data.
 *
 * @template T The type of data in the table rows.
 */
export default function SimpleTable<T>(props: UseSimpleTableProps<T>) {
  const {
    table,
    tableWrapperRef,
    data,
    columnVisibility,
    defaultColumnVisibility,
    defaultColumnOrder,
    toggleSort,
    sortOrder,
    onResetSizing,
    onAutoFitColumn,
    selectionMode,
    toggleSelectionMode,
    exitSelectionMode,
  } = useSimpleTable(props)

  return (
    <SimpleTableComponent
      table={table}
      tableWrapperRef={tableWrapperRef}
      data={data}
      columnVisibility={columnVisibility}
      defaultColumnVisibility={defaultColumnVisibility}
      defaultColumnOrder={defaultColumnOrder}
      toggleSort={toggleSort}
      sortOrder={sortOrder}
      onResetSizing={onResetSizing}
      onAutoFitColumn={onAutoFitColumn}
      filterableColumns={props.filterableColumns}
      showColumnOrdering={props.showColumnOrdering}
      className={props.className}
      onSearchValueChange={props.onSearchValueChange}
      onScroll={props.onScroll}
      wrapperClassName={props.wrapperClassName}
      extraSlot={props.extraSlot}
      extraRightSlot={props.extraRightSlot}
      hideFooter={props.hideFooter}
      enableExport={props.enableExport}
      onExport={props.onExport}
      onFiltersChange={props.onFiltersChange}
      initialFilters={props.initialFilters}
      noDataMessage={props.noDataMessage}
      emptyState={props.emptyState}
      activeSubpage={props.activeSubpage}
      enableHoverStateStyling={props.enableHoverStateStyling}
      enableDeepLinking={props.enableDeepLinking}
      edgePadded={props.edgePadded}
      bulkActions={props.bulkActions}
      selectionMode={selectionMode}
      toggleSelectionMode={toggleSelectionMode}
      exitSelectionMode={exitSelectionMode}
    />
  )
}
